import { css } from 'aphrodite';
import { IFormField } from '../../../../../../../models/Api';
import { styleSheet } from '../styles';

interface IProps {
	field: IFormField<any>;
	value: { fileName: string; attachmentId: string }[];
}
export const CustomFieldFile = ({ field, value }: IProps) => {
	return (
		<div className={css(styleSheet.detailItem)}>
			<span className={css(styleSheet.detailLabel)}>{field?.label}:</span>

			<div>
				{value.map(v => (
					<div className={css(styleSheet.fileName)} key={v.attachmentId}>
						{v.fileName}
					</div>
				))}
			</div>
		</div>
	);
};
